import { useSafetyTranslation } from 'cng-common/features/translations'
import { type IModalContent, ModalDialog } from 'core-components/library/modalDialog'
import { Card } from 'partner360/components/card'
import { registerPlanSectionDeckSlot } from 'partner360/lib/planSectionDialog'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { CockpitCardHeader } from '../../../components/cockpitCardHeader'
import { CockpitFilterSummary } from '../../../components/cockpitFilterSummary'
import { CockpitIconButton } from '../../../components/cockpitIconButton'
import { CockpitDocumentsAndLinksExpanded } from '../../CockpitDocumentsAndLinksExpanded'

import styles from './DocumentsFullscreen.module.scss'

interface IContentProps extends IModalContent {
  title: string
  partnerId?: string
  isManagerCockpitMode?: boolean
}
const DocumentsFullscreenContent = ({
  title,
  partnerId,
  isManagerCockpitMode,
  closeModal,
}: IContentProps) => {
  const t = useSafetyTranslation()
  return (
    <>
      {/* The cockpit draws its plan deck here, over the scrim at the top of the screen. */}
      <div ref={registerPlanSectionDeckSlot} className={styles.deckSlot} />
      <Card
        as="div"
        expanded
        hoverable={false}
        className={styles.card}
        bodyClassName={styles.cardBody}
        header={
          <div className={styles.heading}>
            <CockpitCardHeader
              title={title}
              description={<CockpitFilterSummary expanded bordered={false} period />}
              actions={
                <CockpitIconButton
                  icon="kbase kbase-close"
                  label={t(FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.fullscreen.close)}
                  onClick={closeModal}
                />
              }
            />
          </div>
        }
      >
        <CockpitDocumentsAndLinksExpanded
          fullscreen
          partnerId={partnerId}
          isManagerCockpitMode={isManagerCockpitMode}
        />
      </Card>
    </>
  )
}
interface IProps {
  show: boolean
  title: string
  partnerId?: string
  isManagerCockpitMode?: boolean
  onClose: () => void
}
export const DocumentsFullscreen = ({ show, onClose, ...contentProps }: IProps) => (
  <ModalDialog
    show={show}
    size="fullscreen"
    isContainerRestricted={false}
    closeOnOutsideClick={false}
    classes={{
      overlay: styles.overlay,
      window: styles.window,
      header: styles.modalHeader,
      body: styles.modalBody,
    }}
    content={DocumentsFullscreenContent}
    contentProps={contentProps}
    onClose={onClose}
  />
)
